var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_3697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2886 8.76435H8.94601H6.66211V10.8579H9.1173C9.55505 10.8579 9.9357 10.7437 9.9357 9.73501C9.9357 8.72628 9.2886 8.76435 9.2886 8.76435Z",
    fill: "#61B766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2886 12.3809H6.66211V15.0454H8.96505C9.00312 15.0454 9.06021 15.0454 9.13634 15.0454C9.517 15.0454 10.2402 14.8932 10.2402 13.7512C10.2593 12.3999 9.2886 12.3809 9.2886 12.3809Z",
    fill: "#61B766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9667 0.00976562H6.01427C2.70262 0.00976562 0 2.71238 0 6.02404V17.9955C0 21.2881 2.70262 23.9907 6.01427 23.9907H17.9857C21.2974 23.9907 24 21.2881 24 17.9765V6.02404C23.981 2.71238 21.2784 0.00976562 17.9667 0.00976562ZM14.0841 7.62277H18.0809V8.5744H14.0841V7.62277ZM12.2189 13.8845C12.2189 16.8535 9.28787 16.9487 9.28787 16.9487H6.58525H6.50912H4.5678V7.0518H6.49009H6.56622H9.26883C10.7343 7.0518 11.8953 7.88923 11.8953 9.64022C11.8953 11.3912 10.4869 11.4864 10.4869 11.4864C12.3521 11.4673 12.2189 13.8845 12.2189 13.8845ZM19.3941 13.7132H14.5789C14.5789 15.6164 16.2157 15.4642 16.2157 15.4642C17.7573 15.4642 17.7002 14.4745 17.7002 14.4745H19.337C19.337 17.139 16.1586 17.0248 16.1586 17.0248C12.3521 17.0248 12.5995 13.2754 12.5995 13.2754C12.5995 13.2754 12.5995 9.50699 16.1586 9.50699C19.908 9.48796 19.3941 13.7132 19.3941 13.7132Z",
    fill: "#61B766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1973 10.877C14.7699 10.877 14.5605 12.3805 14.5605 12.3805H17.6057C17.6057 12.3805 17.6248 10.877 16.1973 10.877Z",
    fill: "#61B766"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_3697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.b08ffa365ffe0fc9fd6f8088a28b20b6.svg";
export { ForwardRef as ReactComponent };